<input
  type="file"
  [accept]="acceptedFileTypes"
  #fileInput
  (change)="onFileInputChange()"
  class="cdk-visually-hidden"
  aria-labelledby="attachment-upload-button"
  />
  <div class="file-upload-container">
    @if (dragging) {
      <div class="file-upload-drag-overlay">
        <mat-icon>cloud_upload</mat-icon>
        <span>Drop file to upload</span>
      </div>
    }
    @if (!uploadedFile) {
      <div
        class="file-upload-dropzone"
        tabindex="0"
        role="button"
        id="attachment-upload-button"
        aria-label="Upload Files"
        (click)="onUploadClick($event)"
        (keydown.enter)="onUploadClick($event)"
        >
        <mat-icon class="file-upload-dropzone-icon">cloud_upload</mat-icon>
        <div class="file-upload-dropzone-label">{{ label }}</div>
        <div class="file-upload-dropzone-hint"
          >Drag and drop a file here, or click to browse
          @if (acceptedFileTypes) {
          <span class="file-upload-dropzone-types">({{ acceptedFileTypes }})</span>
          }</div
        >
      </div>
    }
    @if (uploadedFile) {
      <div class="file-attachments">
        <figure class="attachment-metadata-figure">
          @if (fileType == 'audio') {
            <mat-icon>audio_file</mat-icon>
          }
          @if (fileType == 'excel') {
            <mat-icon>insert_drive_file</mat-icon>
          }
          <figcaption class="attachment-caption">
            <ng-container *ngTemplateOutlet="attachmentInfo; context: { $implicit: attachment }"></ng-container>
          </figcaption>
        </figure>
        <ng-template #attachmentInfo>
          <div class="attachment-display-text" id="{{ id }}-display-text">
            {{ uploadedFile.name }}
          </div>
          <div class="attachment-file-info">
            <span [attr.id]="'attachment-file-size-' + id">
              {{ uploadedFile.size | bytes }}
            </span>
            <span>&nbsp;{{ uploadedFile.type }}&nbsp;file </span>
          </div>
        </ng-template>
        <button mat-icon-button type="button" title="Delete Attachment" (click)="onAttachmentDelete(attachment)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>
